import {Observable} from 'rxjs';

import {inject, Injectable, Signal} from '@angular/core';
import {Store} from '@ngrx/store';

import {ApiService} from '../services/api.service';
import {IBackendService, IBackendServiceConfig} from './backend.service.type';

@Injectable({
	providedIn: 'root',
})
export abstract class BackendService<StoreStruct extends object = any, StoreType = StoreStruct extends object ? Store<StoreStruct> : never> implements IBackendService<StoreStruct, StoreType> {
	public readonly apiService: ApiService = inject(ApiService);
	/* -------------------------------------------------------------------------------------------------------------- */
	public store?: StoreType;
	public storeState?: Signal<StoreStruct>;
	public storeObservable?: Observable<StoreStruct>;

	/* -------------------------------------------------------------------------------------------------------------- */
	protected constructor(
		public API_PATH: string,
		public config?: IBackendServiceConfig,
	) {
		if (config?.store) {
			const {storeKey} = config.store;
			if (!storeKey) throw new Error('Store key is required');
			this.store = inject(Store) as StoreType;
			const store: Store<StoreStruct> = this.store as Store<StoreStruct>;
			this.storeState = store.selectSignal<StoreStruct>(state => state[storeKey]);
			this.storeObservable = store.select<StoreStruct>(state => state[storeKey]);
		}
	}

	public getUrl(path?: string): string {
		return `${this.API_PATH}${path ? `/${path}` : ''}`;
	}
}
